import Vue from 'vue'
import { Tabs, Form, Input, Select, Radio, DatePicker, Button, Checkbox, message, Spin, Modal } from 'ant-design-vue'
import SliderVerify from '@/components/slider-verify'

Vue.use(Tabs)
Vue.use(Form)
Vue.use(Input)
Vue.use(Select)
Vue.use(Radio)
Vue.use(DatePicker)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(Spin)
Vue.use(SliderVerify)
Vue.prototype.$message = message
Vue.prototype.$error = Modal.error
